import { DotLegalDialog, DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { BestPracticeCheckDialogProps } from "./BestPracticeCheckDialog.types";
import { useBestPracticeCheckDialog } from "./BestPracticeCheckDialog.hooks";
import BestPracticeCheckDialogContent from "./BestPracticeCheckDialogContent";
import { Box } from "@mui/material";
import AIDialogDisclaimer from "@common/components/AIDialogDisclaimer.tsx";
import { useAiSpendingWarning } from "../../../aiAdministration/AiAdministration.hooks";
import { isAiSpendingExhausted } from "../../../aiAdministration/AiAdministration.types";

function BestPracticeCheckDialog(props: BestPracticeCheckDialogProps) {
    const { translateString } = useTranslation();
    const { selectedTemplateId, setSelectedTemplateId, isLoadingTemplates, templateOptions, onOkClick, isComparing } = useBestPracticeCheckDialog(props);
    const { data: spendingWarning } = useAiSpendingWarning();
    const isAiExhausted = isAiSpendingExhausted(spendingWarning);

    return (
        <DotLegalDialog
            header={translateString("aiQualityScan")}
            buttonOkText={translateString("compare")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onOkClick}
            okButtonDisabled={!selectedTemplateId || isComparing || isAiExhausted}
            inProgress={isComparing}
            isLoading={isLoadingTemplates}
            size={"sm"}
            footer={<AIDialogDisclaimer />}
        >
            <BestPracticeCheckDialogContent
                selectedTemplateId={selectedTemplateId}
                setSelectedTemplateId={setSelectedTemplateId}
                templateOptions={templateOptions}
                isComparing={isComparing}
                spendingWarning={spendingWarning}
            />
        </DotLegalDialog>
    );
}

export default BestPracticeCheckDialog;
